import axios, { AxiosResponse } from "axios";
import { LogEvent, PlatformEventPageRequest } from "../../models/LogEvents";

const getTwilioPlatformEventPage =
	(productId: string, request: PlatformEventPageRequest) => async (): Promise<AxiosResponse<LogEvent[]>> => {
		return await axios.post(`/api/v1/${productId}/platformEvents/GetPlatformEventsList/`, request);
	};

export { getTwilioPlatformEventPage };
